module.exports = __webpack_public_path__ + "static/media/480.347c40b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-room/dark/480.png
// module id = 2390
// module chunks = 2